import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import * as FlashActions from '../../../components/flash-message/actions'
import * as Request from '../../../request'
import * as Constants from './constants'

export const messageOnSendPayload: ReduxObservable.Epic<any, any> =
  (action$: ReduxObservable.ActionsObservable<Redux.Action>) =>
  action$.ofType(Request.successConstant(Constants.SEND_EMAIL_FUTURE_DATE))
  .map((action) => checkPayloadStatus(action))

const checkPayloadStatus = (action: any) => {
  if (action.payload.response.statusMessage === Constants.CONTENT_FAILURE) {
    return FlashActions.showFlashWarning(Constants.CONTENT_FAILURE_MESSAGE)
  } else if (action.payload.response.statusMessage === Constants.SEND_SUCCESS) {
    return FlashActions.showFlashMessage(Constants.SEND_SUCCESS_MESSAGE)
  } else {
    return FlashActions.showFlashError(Constants.OTHER_FAILURE_MESSAGE)
  }
}

export const epic = ReduxObservable.combineEpics(
    messageOnSendPayload,
  )



// WEBPACK FOOTER //
// ./src/pages/content-calendar/send-email-modal/epic.ts